export const NAMESPACE = 'STATS_POSTS_COMMUNITY/';

export const SET_SOURCE = NAMESPACE + 'SET_SOURCE';
export const SET_POST_TYPE = NAMESPACE + 'SET_POST_TYPE';
export const SET_ONLY_WITH_VK_CC = NAMESPACE + 'SET_ONLY_WITH_VK_CC';
export const SET_START_DATE = NAMESPACE + 'SET_START_DATE';
export const SET_END_DATE = NAMESPACE + 'SET_END_DATE';

export const SET_SUBPROGRESS = NAMESPACE + 'SET_SUBPROGRESS';
